export const MAX_PAYLOAD_SIZE = 100 * 1024 * 1024; // 100 MB

// Live transcription chunk size. Kept small on purpose: on a weak mobile link a
// 5 MB chunk takes minutes to upload and the transcript falls far behind the
// conversation. 1 MB is ~4 min of 16 kHz mono speech audio.
export const AUDIO_CHUNK_SIZE_MB = 1;

// Upload retry policy shared by the web chunk queue and the mobile upload queue.
export const UPLOAD_MAX_ATTEMPTS = 5;
export const UPLOAD_RETRY_BASE_DELAY_MS = 2_000;
export const UPLOAD_RETRY_MAX_DELAY_MS = 60_000;

/** Exponential backoff with ±20% jitter, capped at UPLOAD_RETRY_MAX_DELAY_MS. */
export function uploadRetryDelayMs(attempt: number, random = Math.random): number {
  const exponential = UPLOAD_RETRY_BASE_DELAY_MS * 2 ** Math.max(0, attempt - 1);
  const capped = Math.min(exponential, UPLOAD_RETRY_MAX_DELAY_MS);
  const jitter = capped * 0.2 * (random() * 2 - 1);
  return Math.round(capped + jitter);
}
